import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.modules.disablePromptHeader'),
      "open": _vm.moduleDisablePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
        color: _vm.color,
        emit: 'disable'
      }]
    },
    on: {
      "cancel": _vm.cancelModuleDisablement,
      "disable": function ($event) {
        return _vm.toggleModule(_vm.moduleToDisable);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('accMgmt.system.modules.disableConfirmation')) + "\n  ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.modules.superAdminModule'),
      "open": _vm.superAdminModuleInteraction,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        color: _vm.color,
        emit: 'cancel'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.superAdminModuleInteraction = false;
      }
    }
  }), _c(VForm, {
    ref: "mainForm",
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c('core-header', {
    attrs: {
      "headline": `niotix ${_vm.$i18n_t('Common.modulesIntegrations')}`,
      "subtitle": _vm.$i18n_t('accMgmt.system.modules.description')
    }
  }), _c('div', {
    staticClass: "n20-mainrow pt-4"
  }, [_c('core-n20Card', {
    staticClass: "mb-4"
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-0 mb-2 py-0"
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.modules.helptext')))])])], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "my-0 py-0"
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.tenants,
      "color": _vm.color,
      "value": _vm.selectedTenantId,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "data-cy": "tenant_selector"
    },
    on: {
      "input": _vm.selectTenant
    }
  })], 1)], 1), _vm.loadingModules === true ? _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, _vm._l([0, 1, 2], function (i) {
    return _c(VCol, {
      key: `module_skeleton_${i}`,
      attrs: {
        "cols": "12"
      }
    }, [_c(VRow, {
      staticClass: "my-0 py-0",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "list-item-avatar"
      }
    })], 1)], 1), _c(VRow, {
      staticClass: "my-0 py-0"
    }, [_c(VCol, {
      staticClass: "my-0 py-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    }), _c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1)], 1), _vm._l([0, 1], function (j) {
      return _c(VRow, {
        key: `module_skeleton_${i}_${j}`,
        staticClass: "my-0 py-0",
        attrs: {
          "align": "center"
        }
      }, [_c(VCol, {
        staticClass: "pr-0 mr-0",
        attrs: {
          "cols": "1"
        }
      }, [_c(VSkeletonLoader, {
        attrs: {
          "type": "button"
        }
      })], 1), _c(VCol, {
        staticClass: "py-0 pl-0"
      }, [_c(VRow, {
        staticClass: "my-0 py-0"
      }, [_c(VCol, {
        attrs: {
          "cols": "5"
        }
      }, [_c(VSkeletonLoader, {
        attrs: {
          "type": "text"
        }
      }), _c(VSkeletonLoader, {
        attrs: {
          "type": "text"
        }
      })], 1)], 1)], 1)], 1);
    }), _c(VDivider, {
      staticClass: "mt-4"
    })], 2);
  }), 1) : _vm._l(_vm.modules, function (moduleModel, i) {
    return _c(VRow, {
      key: `module_${i}`,
      staticStyle: {
        "min-width": "0"
      }
    }, [_c(VCol, {
      staticClass: "pt-1 pb-0 my-0",
      attrs: {
        "cols": "12"
      }
    }, [_vm.loadingModules === moduleModel.key ? [_c(VRow, {
      staticClass: "my-0 py-0",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "list-item-avatar"
      }
    })], 1)], 1), _c(VRow, {
      staticClass: "my-0 py-0"
    }, [_c(VCol, {
      staticClass: "my-0 py-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    }), _c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1)], 1), _vm._l([0, 1], function (j) {
      return _c(VRow, {
        key: `module_skeleton_${i}_${j}`,
        staticClass: "my-0 py-0",
        attrs: {
          "align": "center"
        }
      }, [_c(VCol, {
        staticClass: "pr-0 mr-0",
        attrs: {
          "cols": "1"
        }
      }, [_c(VSkeletonLoader, {
        attrs: {
          "type": "button"
        }
      })], 1), _c(VCol, {
        staticClass: "py-0 pl-0"
      }, [_c(VRow, {
        staticClass: "my-0 py-0"
      }, [_c(VCol, {
        attrs: {
          "cols": "5"
        }
      }, [_c(VSkeletonLoader, {
        attrs: {
          "type": "text"
        }
      }), _c(VSkeletonLoader, {
        attrs: {
          "type": "text"
        }
      })], 1)], 1)], 1)], 1);
    })] : [_c(VSwitch, {
      key: `module_state_${moduleModel.tempKey || i}`,
      attrs: {
        "input-value": moduleModel.isEnabled,
        "color": _vm.color,
        "inset": "",
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.confirmModuleDisable(moduleModel, $event);
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_c('h4', {
            style: `opacity: ${moduleModel.isEnabled ? 1.0 : 0.45}`
          }, [_c(VIcon, {
            attrs: {
              "color": moduleModel.isEnabled ? _vm.color : undefined
            }
          }, [_vm._v("\n                        " + _vm._s(moduleModel.manifest.icon) + "\n                      ")]), _vm._v("\n                      " + _vm._s(moduleModel.manifest.name) + " (" + _vm._s(moduleModel.key) + ")\n                      "), moduleModel.manifest.superAdminModule ? _c(VIcon, {
            attrs: {
              "color": moduleModel.isEnabled ? _vm.color : undefined,
              "small": "",
              "left": ""
            }
          }, [_vm._v("\n                        fal fa-users-crown\n                      ")]) : _vm._e()], 1)];
        },
        proxy: true
      }], null, true)
    }), _c('div', {
      style: `opacity: ${moduleModel.isEnabled ? 1.0 : 0.65}`
    }, [moduleModel.manifest.superAdminModule ? _c('p', {
      staticClass: "card-description"
    }, [_c('em', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.modules.superAdminModule')))])]) : _vm._e(), _c('p', {
      domProps: {
        "innerHTML": _vm._s(moduleModel.manifest.description)
      }
    }), (moduleModel.roles || []).length ? [_c('p', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.modules.defaultRoles')))]), _vm._l(moduleModel.roles, function (role, j) {
      return _c(VCheckbox, {
        key: `module_${i}_role_${j}`,
        attrs: {
          "disabled": !moduleModel.isEnabled,
          "color": _vm.color,
          "hide-details": ""
        },
        on: {
          "change": function ($event) {
            return _vm.toggleDefaultRole(role);
          }
        },
        scopedSlots: _vm._u([{
          key: "label",
          fn: function () {
            return [_c('p', {
              staticClass: "mb-0"
            }, [_c('span', {
              staticClass: "text-bold"
            }, [_vm._v(_vm._s(role.name))]), _c('br'), _vm._v("\n                          " + _vm._s(role.description) + "\n                        ")])];
          },
          proxy: true
        }], null, true),
        model: {
          value: role.isDefault,
          callback: function ($$v) {
            _vm.$set(role, "isDefault", $$v);
          },
          expression: "role.isDefault"
        }
      });
    })] : _vm._e(), moduleModel.manifest.key === 'wMBus' || moduleModel.manifest.key === 'LwM2M' ? [_c(VCheckbox, {
      attrs: {
        "disabled": !moduleModel.isEnabled,
        "color": _vm.color,
        "hide-details": ""
      },
      on: {
        "change": () => {
          _vm.toggleModule(moduleModel);
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_c('p', {
            staticClass: "mb-0"
          }, [_c('span', {
            staticClass: "text-bold"
          }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.modules.activateDeviceLimit')))])])];
        },
        proxy: true
      }], null, true),
      model: {
        value: moduleModel.settings.activeDeviceLimit,
        callback: function ($$v) {
          _vm.$set(moduleModel.settings, "activeDeviceLimit", $$v);
        },
        expression: "moduleModel.settings.activeDeviceLimit"
      }
    }), moduleModel.settings.activeDeviceLimit ? _c(VRow, {
      staticClass: "mt-0 pt-0",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      attrs: {
        "xs": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "label": _vm.$i18n_t('accMgmt.system.modules.maxNumberOfDevices'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "disabled": !moduleModel.isEnabled,
        "rules": [_vm.positiveNumberRule],
        "hide-details": "auto",
        "required": ""
      },
      on: {
        "blur": () => {
          _vm.toggleModule(moduleModel);
        }
      },
      model: {
        value: moduleModel.settings.deviceLimit,
        callback: function ($$v) {
          _vm.$set(moduleModel.settings, "deviceLimit", $$v);
        },
        expression: "moduleModel.settings.deviceLimit"
      }
    })], 1)], 1) : _vm._e()] : _vm._e()], 2)], _c(VDivider, {
      staticClass: "mt-4"
    })], 2)], 1);
  })], 2), _c('core-n20Card', {
    staticClass: "mt-2 mb-3"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.retentionPolicy')))]), _c('p', {
    staticClass: "card-description"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.retentionPolicyText')))]), _c(VRow, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": _vm.effectiveRetentionPolicyMonths,
      "label": _vm.$i18n_t('accMgmt.tenant.integrations.retentionLength'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.permissions['super.system.manage'],
      "rules": _vm.retentionPolicyRules,
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "input": _vm.onRetentionPolicyInput
    }
  })], 1)], 1), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.csvExoprtsLimit')))]), _c('p', {
    staticClass: "card-description"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.numberLimit')))]), _c(VRow, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.tenant.integrations.allowedNumbers'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.permissions['super.system.manage'],
      "rules": [_vm.positiveNumberRule],
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "input": e => {
        _vm.tenantModel.data.csvExportLimit = parseFloat(e);
        _vm.updateCsvExportLimit();
      }
    },
    model: {
      value: _vm.tenantModel.data.csvExportLimit,
      callback: function ($$v) {
        _vm.$set(_vm.tenantModel.data, "csvExportLimit", $$v);
      },
      expression: "tenantModel.data.csvExportLimit"
    }
  })], 1)], 1), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.dashboardDatapointLimit')))]), _c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.dashboardDatapointLimitText')) + "\n        ")]), _c(VRow, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.tenant.integrations.dashboardDatapointLimitInput'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.permissions['super.system.manage'],
      "rules": [_vm.positiveNumberRule],
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "input": e => {
        _vm.tenantModel.data.dashboardDatapointLimit = parseFloat(e);
        _vm.updateDashboardDatapointLimit();
      }
    },
    model: {
      value: _vm.tenantModel.data.dashboardDatapointLimit,
      callback: function ($$v) {
        _vm.$set(_vm.tenantModel.data, "dashboardDatapointLimit", $$v);
      },
      expression: "tenantModel.data.dashboardDatapointLimit"
    }
  })], 1)], 1), _c('h4', {
    staticStyle: {
      "opacity": "1",
      "padding-top": "5px"
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-sitemap")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.deviceTemplates')) + "\n          "), _c(VIcon, {
    attrs: {
      "color": _vm.color,
      "small": "",
      "left": ""
    }
  }, [_vm._v("fal fa-users-crown")])], 1), _c('p', {
    staticClass: "card-description",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.deviceTemplatesDescription')) + "\n        ")]), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "pt-0 pb-3 my-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "inset": "",
      "label": _vm.$i18n_t('accMgmt.tenant.integrations.useCustomTemplateLimit'),
      "hide-details": "",
      "disabled": !_vm.permissions['super.system.manage']
    },
    on: {
      "change": () => {
        _vm.updateDeviceTemplateSettings();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('p', {
          staticStyle: {
            "margin": "0"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.useCustomTemplateLimit')) + "\n                ")]), _vm._v("\n                 \n              ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.tenantModel.data.useCustomTemplateLimit,
      callback: function ($$v) {
        _vm.$set(_vm.tenantModel.data, "useCustomTemplateLimit", $$v);
      },
      expression: "tenantModel.data.useCustomTemplateLimit"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "xs": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.tenant.integrations.allowedNumbersOfTemplates'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.permissions['super.system.manage'] || !_vm.hasCustomLimit,
      "rules": [_vm.positiveNumberRule],
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "input": e => {
        _vm.tenantModel.data.templateLimit = parseInt(e);
        _vm.updateDeviceTemplateSettings();
      }
    },
    model: {
      value: _vm.tenantModel.data.templateLimit,
      callback: function ($$v) {
        _vm.$set(_vm.tenantModel.data, "templateLimit", $$v);
      },
      expression: "tenantModel.data.templateLimit"
    }
  })], 1)], 1), _vm._v("\n         \n\n        "), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.header')))]), _c(VRow, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "align": "center"
    }
  }, [_c('core-tenant-details-integrations', {
    attrs: {
      "accountId": _vm.selectedTenantId
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };